module.exports = __webpack_public_path__ + "officialStatic/img/product-bg.4d2c9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-bg.png
// module id = coB8
// module chunks = 0